import classNames from 'classnames';

import { AppLogo } from '../../../../components/SVGIcons/AppLogo/AppLogo';

import classes from './HeaderLogoElement.module.scss';

export const HeaderLogoElement = ({
  position = 'left',
  ...props
}: {
  showLogo: boolean;
  position?: 'left' | 'right';
  onClick?: () => void;
}) => {
  return (
    <div
      className={classNames(classes.headerLogoElement, {
        [classes.left]: position === 'left',
        [classes.right]: position === 'right',
      })}
      onClick={props.onClick}
    >
      {props.showLogo ? <AppLogo alwaysColorful /> : null}
    </div>
  );
};
